import { IllegalArgumentError } from 'faro-common-model';
export function checkPositiveNumber(value, propertyPath) {
    if (Number.isNaN(value)) {
        throw new IllegalArgumentError(`${propertyPath} must be a positive number, but instead was [${value}]`);
    }
    const numberValue = Number(value);
    if (numberValue < 0) {
        throw new IllegalArgumentError(`${propertyPath} must be a positive number, but instead was [${value}]`);
    }
    return numberValue;
}
//# sourceMappingURL=checkPositiveNumber.js.map